module.exports = __webpack_public_path__ + "static/media/if1.9dd79812.svg";